import React from 'react';
import { css, Global } from '@emotion/react';
import { paletteColor } from './NutailTheme';

// The app palette as CSS variables, so superadmin's plain stylesheets can use it
// (they can't call paletteColor). PAL 9.13, BT-10863.
const PALETTE_VARS = {
  '--palette-primary': paletteColor('primary.main'),
  '--palette-primary-tint': paletteColor('activity_info.light'),
  '--palette-ai': paletteColor('activity_ai.main'),
  '--palette-ai-tint': paletteColor('activity_ai.light'),
  '--palette-success': paletteColor('activity_success.main'),
  '--palette-success-tint': paletteColor('activity_success.light'),
  '--palette-warning': paletteColor('activity_warning.main'),
  '--palette-warning-tint': paletteColor('activity_warning.light'),
  '--palette-danger': paletteColor('activity_danger.main'),
  '--palette-danger-tint': paletteColor('activity_danger.light'),
  '--palette-ink': paletteColor('text.primary'),
  '--palette-text-secondary': paletteColor('text.secondary'),
  '--palette-muted': paletteColor('activity_muted.main'),
  '--palette-border': paletteColor('divider'),
  '--palette-subtle-surface': paletteColor('activity_neutral.light'),
  '--palette-surface': paletteColor('background.paper'),
  '--palette-backdrop': paletteColor('modern_backdrop.main'),
  '--palette-white': paletteColor('common.white'),
};

const style = css({
  ':root': PALETTE_VARS,
  'html, body': {
    fontSize: '14px',
  },
  '*': {
    fontSize: 'inherit',
  },
  '.MuiDataGrid-root .MuiDataGrid-cell': {
    fontSize: '14px',
  },
  '.MuiDataGrid-root .MuiDataGrid-columnHeader': {
    fontSize: '14px',
  },
  '.MuiDataGrid-root .MuiDataGrid-footerContainer': {
    fontSize: '14px',
  },
  '.MuiDataGrid-root .MuiTablePagination-root': {
    fontSize: '14px',
  },
  '.MuiTypography-root': {
    fontSize: '14px',
  },
  'button, input, select, textarea': {
    fontSize: '14px',
  },
  // Ensure any small text is at least 12px
  'small, .small': {
    fontSize: '12px !important',
  },
});

function StyleRoot() {
  return (
    <Global
      styles={style}
    />
  );
}

export default StyleRoot;
